// Mảnh SVG dùng chung cho các mặt la bàn. Hình học nằm ở lib/la-ban-geometry.ts.
import type React from "react";

import { cungChu } from "@/lib/la-ban-geometry";

/** Chữ chạy theo vòng cung, canh giữa cung. */
export function ChuCung({
  id,
  r,
  goc,
  doRong,
  children,
  className,
  style,
}: {
  id: string;
  r: number;
  goc: number;
  doRong: number;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <>
      <path id={id} d={cungChu(r, goc, doRong)} fill="none" />
      <text className={className} style={style} textAnchor="middle" dominantBaseline="central">
        <textPath href={`#${id}`} startOffset="50%">
          {children}
        </textPath>
      </text>
    </>
  );
}
